import { render, staticRenderFns } from "./ChartInfoForm.vue?vue&type=template&id=5801b2da&"
import script from "./ChartInfoForm.vue?vue&type=script&lang=ts&"
export * from "./ChartInfoForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports